import { I18nPluralPipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { lucideBadgeCheck, lucideClock } from '@ng-icons/lucide';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmRadioGroupImports } from '@spartan-ng/helm/radio-group';
import { classes } from '@spartan-ng/helm/utils';
import { Module } from '../../../models/module.model';

@Component({
  selector: 'app-item-module',
  imports: [HlmRadioGroupImports, HlmIconImports, I18nPluralPipe],
  templateUrl: './item-module.component.html',
  providers: [provideIcons({ lucideClock, lucideBadgeCheck })],
})
export class ItemModuleComponent {
  readonly module = input.required<Module>();

  protected readonly heureMapping: { [k: string]: string } = {
    '=0': '# heure',
    '=1': '# heure',
    other: '# heures',
  };

  constructor() {
    classes(() => 'gap-md px-md pt-sm pb-md flex w-full flex-col');
  }
}
